'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setEntry = undefined;

var _curry = require('transmute/curry');

var _curry2 = _interopRequireDefault(_curry);

var _set = require('transmute/set');

var _set2 = _interopRequireDefault(_set);

var _keyPaths = require('../constants/keyPaths');

var _indexedDataInvariant = require('../invariants/indexedDataInvariant');

var _applyIdTransform = require('./applyIdTransform');

var _applyIdInvariant = require('./applyIdInvariant');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Set an entry in IndexedAsyncData
 *
 * @param {Any} id an id that passes the id invariant
 * @param {Any} data data to set
 * @param {IndexedAsyncData} indexedData IndexedAsyncData to set the entry in
 * @returns {IndexedAsyncData}
 */
var setEntry = exports.setEntry = (0, _curry2.default)(function (id, data, indexedData) {
  (0, _indexedDataInvariant.indexedDataInvariant)(indexedData);
  (0, _applyIdInvariant.applyIdInvariant)(id, indexedData);

  var key = (0, _applyIdTransform.applyIdTransform)(id, indexedData);
  return indexedData.updateIn(_keyPaths.ENTRIES, (0, _set2.default)(key, data));
});


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-schema/static-1.4266/js/indexed-async-data/operators/setEntry.js
// module id = 614
// module chunks = 2 3